/* What sets each benchmarked industry apart, in one line: its home page card
   and the first thing its own page says under "What we found". Approved
   2026-10-14 in `docs/industry-pages/drafts.md`.

   **One sentence ten times over is what this replaced.** Every card read "A
   typical answer named 5.x businesses", which buried the findings that differ.

   **Every figure is read from `benchmark.json`, and every "most" or "lowest"
   is checked against the other nine** by `industry_pages_test`, so a re-run
   that changes a ranking fails a test rather than leaving a card false. The
   pest control and senior care lines are held by `benchmark_post_test`, which
   already guards the same sentences on the benchmark post. */
import { by, listingShare, ownShare, count, word } from '~/marketing/research/figures';

const pct = n => `${Math.round(n)}%`;
const most = (cities, f) => cities.reduce((a, c) => (f(c) > f(a) ? c : a));

const FINDINGS = {
  hvac: b => `All ${count(b.named.of)} answers about who to call named a specific company.`,
  plumbing: () => 'In every city, the three most-named plumbers took less than a fifth of all mentions.',
  roofing: () => 'The three most-named roofers took nearly a third of all mentions in every city.',
  electrical: b => `Electricians’ own websites were ${pct(ownShare(b))} of sources, the lowest share we measured.`,
  pest_control: () => 'National chains led in Dallas. In Boise, local companies led instead.',
  // "More than 140" from a fewest of 141: the tens below the smallest city.
  landscaping: b => `More than ${Math.floor((Math.min(...b.cities.map(c => c.brands)) - 1) / 10) * 10} landscapers were named in every city.`,
  accounting: b => {
    const c = most(b.cities, x => x.brands);
    return `${count(c.brands)} accountants were named in ${c.city}, the most in any city we measured.`;
  },
  family_law: b => `${pct(listingShare(b))} of sources were directories, review sites and other listings, the highest share we measured.`,
  chiropractic: b => `Only ${pct(listingShare(b))} of sources were listings, the lowest share we measured.`,
  home_care: b => `One franchise was written as many as ${word(Math.max(...b.cities.map(c => c.most_spellings.names)))} ways in a single city.`,
  // Added with their pages, 2026-10-14.
  med_spa: b => `All ${count(b.named.of)} answers asking for a recommendation named a specific med spa.`,
  pi_law: b => `Lawyers’ own websites were ${pct(ownShare(b))} of sources, the highest share we measured.`,
  dental: b => `In every city, the three most-named dentists took only about ${pct(Math.max(...b.cities.map(c => c.top3_by_brand)))} of all mentions.`,
};

export function findingFor(key) {
  const finding = FINDINGS[key];
  if (!finding) throw new Error(`industryFindings: no finding for ${key}`);
  return finding(by[key]);
}
